export const hospitalRoomBoardColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'amount',
  'fk_hospital__data_doc_new_id',
  'quantity',
  'revenue_code',
  'service_date',
  'snapshot_id',
];
